'use strict';

var _ = require('lodash');
var SimpleHepToggleService = function SimpleHepToggleService() {
  var simpleHepMap = {};
  function initialize(hepMap) {
    simpleHepMap = _.clone(hepMap);
  }
  function isMatching(expression, value) {
    var groupExpression = parseExpression(expression, ';', ',');
    var groupValue = parseExpression(value, ';;;', ',,,');
    return evaluate(groupExpression, groupValue, isMatchingEval);
  }
  function parseExpression(expression, andSplitCharacter, orSplitCharacter) {
    if (!_.isString(expression)) {
      return [[expression]];
    }
    expression = expression.replace(/\s/g, '');
    var andGroups = expression.split(andSplitCharacter);
    return _.map(andGroups, function (orGroup) {
      return orGroup.split(orSplitCharacter);
    });
  }
  function evaluate(parsedExpressions, parsedValue, evalFunction) {
    return _.reduce(parsedExpressions, function (result, andGroup, andGroupKey) {
      return result && _.reduce(andGroup, function (result, orGroup, orGroupKey) {
        return result || evalFunction.call(undefined, orGroup, parsedValue[andGroupKey][orGroupKey]);
      }, false);
    }, true);
  }
  function isMatchingEval(attrName, value) {
    return simpleHepMap[attrName] === value;
  }
  return {
    initialize: initialize,
    isMatching: isMatching
  };
};
SimpleHepToggleService.$inject = [];
module.exports = SimpleHepToggleService;